import { IProfile } from '@/types'
import { TEAM_ROUTES } from '@/utils/routes'
import settings from '@/settings/public'

export interface OnboardingContext {
  profile: IProfile
  isNewUser: boolean
  authProvider?: string | null
  sessionStorage: Storage
  localStorage: Storage
}

export interface OnboardingStep {
  name: string
  route: string
  shouldShow: (context: OnboardingContext) => boolean
}

// Helpers
const getSessionFlag = (storage: Storage, key: string): boolean => storage.getItem(key) === 'true'
const getLocalFlag = (storage: Storage, key: string): boolean => storage.getItem(key) === 'true'

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    name: 'welcome',
    route: '/welcome',
    shouldShow: ({ isNewUser, authProvider }) => {
      const allowedProviders = ['joinnus']
      return isNewUser && allowedProviders.includes(authProvider || '')
    },
  },
  {
    name: 'pick-team',
    route: TEAM_ROUTES.pickTeam,
    shouldShow: (ctx) => {
      const { profile, sessionStorage, localStorage, authProvider } = ctx
      const appCode = settings.app.code

      if (!appCode) return false

      // If Cinematics Auth scene explicitly redirected to Home
      if (sessionStorage.getItem('auth_scene_redirect') === '/') return false

      // If provider manages its own flow (ej. Joinnus has its own welcome)
      if (['joinnus'].includes(authProvider || '')) return false

      const welcomeShown = getSessionFlag(sessionStorage, 'welcome_shown_session')
      const pickTeamShown = getSessionFlag(sessionStorage, 'pick_team_shown_session')
      const userSkipped = getLocalFlag(localStorage, `skip_pick_team_${profile?._id}`)

      if (welcomeShown || pickTeamShown || userSkipped) return false

      const userTeams = profile?.teams?.[appCode as keyof typeof profile.teams] || []
      const hasFavoriteTeam = userTeams.some((team: any) => team.favorite)

      return !hasFavoriteTeam
    }
  }
]

export const isOnboardingRoute = (route: string): boolean => ONBOARDING_STEPS.some(step => route.includes(step.route))